import React, { useState } from 'react';
import { Icon, useTheme } from '@Sage/hoi-poi-ui';
import './styles.scss';

const ButtonWidgetViewDetails = ({ onClick }) => {
    let [addButtonHovered, setAddButtoHovered] = useState(false);
    const theme = useTheme();

    const handleMouseOver = () => setAddButtoHovered(true);

    const handleMouseOut = () => setAddButtoHovered(false);

    return (
        <Icon
            name="addCircle"
            size="large"
            color={
                !addButtonHovered ? theme.colors.actionMajor[500] : theme.colors.actionMajor[600]
            }
            onClick={onClick || null}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        />
    );
};

export default ButtonWidgetViewDetails;
